<script setup>
import { onMounted, onUnmounted } from 'vue'
import Card from './Card.vue'

const emit = defineEmits(['close'])

defineProps({
  title: {
    type: String,
    required: true,
  },
  size: {
    type: String,
    default: 'md',
    validator: (value) => ['sm', 'md', 'lg'].includes(value),
  },
})

const handleEscape = (event) => {
  if (event.key === 'Escape') {
    emit('close')
  }
}

onMounted(() => {
  document.body.style.overflow = 'hidden'
  document.addEventListener('keydown', handleEscape)
})

onUnmounted(() => {
  document.body.style.overflow = 'auto'
  document.removeEventListener('keydown', handleEscape)
})
</script>

<template>
  <teleport to="body">
    <div class="modal-container">
      <div class="modal-overlay" @click="emit('close')"></div>
      <div
        :class="{
          'modal-content': true,
          [`modal-content-${size}`]: true,
        }"
      >
        <Card
          :header="title"
          header-icon="close"
          background-color="bg-dark"
          @header-icon-click="emit('close')"
        >
          <slot />
        </Card>
      </div>
    </div>
  </teleport>
</template>

<style scoped>
.modal-container {
  @apply fixed top-0 left-0 w-full h-full grid place-items-center;
  @apply z-[1020];

  .modal-overlay {
    @apply absolute top-0 left-0 w-full h-full bg-black opacity-50 cursor-pointer;
  }

  .modal-content {
    @apply opacity-0 scale-95;
    @apply max-h-[90vh] overflow-y-auto;
    animation: pop-in 0.5s ease forwards;

    &.modal-content-sm {
      @apply w-1/3 min-w-[500px];
    }

    &.modal-content-md {
      @apply w-2/3;
    }

    &.modal-content-lg {
      @apply w-3/4;
    }
  }
}

@keyframes pop-in {
  50% {
    @apply opacity-100 scale-[1.01];
  }
  100% {
    @apply opacity-100 scale-100;
  }
}
</style>
